const Ephemeris = (() => {
  const DEG = 180 / Math.PI;
  const RAD = Math.PI / 180;

  function lahiriAyanamsa(year, month, day) {
    const jd = julianDay(year, month, day);
    const T = (jd - 2451545.0) / 36525.0;
    return 23.85 + 0.01397 * (jd - 2451545.0) / 365.25;
  }

  function julianDay(year, month, day) {
    if (month <= 2) { year--; month += 12; }
    const A = Math.floor(year / 100);
    const B = 2 - A + Math.floor(A / 4);
    return Math.floor(365.25 * (year + 4716)) + Math.floor(30.6001 * (month + 1)) + day + B - 1524.5;
  }

  function toSidereal(tropicalDeg, ayanamsa) {
    return ((tropicalDeg - ayanamsa) % 360 + 360) % 360;
  }

  function rashiIndex(siderealDeg) {
    return Math.floor(siderealDeg / 30) % 12;
  }

  function meanLunarNode(jd) {
    const T = (jd - 2451545.0) / 36525.0;
    let omega = 125.04452 - 1934.136261 * T + 0.0020708 * T * T;
    return ((omega % 360) + 360) % 360;
  }

  function calculateLagna(jd, lat, lng, obliquity, ayanamsa) {
    const T = (jd - 2451545.0) / 36525.0;
    let gmst = 280.46061837 + 360.98564736629 * (jd - 2451545.0) + 0.000387933 * T * T;
    gmst = ((gmst % 360) + 360) % 360;
    const lst = ((gmst + lng) % 360 + 360) % 360;
    const lstRad = lst * RAD;
    const oblRad = obliquity * RAD;
    const latRad = lat * RAD;

    let lagnaRad = Math.atan2(
      Math.cos(lstRad),
      -(Math.sin(oblRad) * Math.tan(latRad) + Math.cos(oblRad) * Math.sin(lstRad))
    );
    let lagnaDeg = lagnaRad * DEG;
    lagnaDeg = ((lagnaDeg % 360) + 360) % 360;

    return toSidereal(lagnaDeg, ayanamsa);
  }

  function calculate(year, month, day, hour, minute, lat, lng, tz) {
    if (typeof Astronomy === "undefined") {
      throw new Error("astronomy-engine not loaded");
    }

    const utcHour = hour - tz;
    let utcDay = day;
    let utcMonth = month;
    let utcYear = year;
    if (utcHour < 0) {
      utcDay--;
      if (utcDay < 1) {
        utcMonth--;
        if (utcMonth < 1) { utcMonth = 12; utcYear--; }
        utcDay = new Date(utcYear, utcMonth, 0).getDate();
      }
    }
    if (utcHour >= 24) {
      utcDay++;
      const maxDay = new Date(utcYear, utcMonth, 0).getDate();
      if (utcDay > maxDay) { utcDay = 1; utcMonth++; }
      if (utcMonth > 12) { utcMonth = 1; utcYear++; }
    }
    const utcH = ((utcHour % 24) + 24) % 24;
    const utcM = minute || 0;

    const date = new Date(Date.UTC(utcYear, utcMonth - 1, utcDay, Math.floor(utcH), utcM));
    const astroTime = Astronomy.MakeTime(date);

    const ayanamsa = lahiriAyanamsa(year, month, day);
    const jd = julianDay(year, month, day) + (hour + (minute || 0) / 60) / 24;

    const planets = {};
    const BODIES = {
      Sun: "Sun", Moon: "Moon", Mars: "Mars",
      Mercury: "Mercury", Jupiter: "Jupiter",
      Venus: "Venus", Saturn: "Saturn",
    };

    for (const [key, body] of Object.entries(BODIES)) {
      let tropLon;
      if (key === "Sun") {
        const sunPos = Astronomy.SunPosition(astroTime);
        tropLon = sunPos.elon;
      } else if (key === "Moon") {
        const moonPos = Astronomy.EclipticGeoMoon(astroTime);
        tropLon = moonPos.lon;
      } else {
        const vec = Astronomy.GeoVector(body, astroTime, true);
        const ecl = Astronomy.Ecliptic(vec);
        tropLon = ecl.elon;
      }

      const sidLon = toSidereal(tropLon, ayanamsa);
      planets[key] = {
        tropical: tropLon,
        longitude: sidLon,
        rashiIndex: rashiIndex(sidLon),
      };
    }

    // Rahu (mean lunar node) and Ketu
    const rahuTrop = meanLunarNode(jd);
    const rahuSid = toSidereal(rahuTrop, ayanamsa);
    planets.Rahu = { tropical: rahuTrop, longitude: rahuSid, rashiIndex: rashiIndex(rahuSid) };

    const ketuSid = (rahuSid + 180) % 360;
    planets.Ketu = { tropical: (rahuTrop + 180) % 360, longitude: ketuSid, rashiIndex: rashiIndex(ketuSid) };

    // Lagna
    const obliquity = 23.4393 - 0.0130 * ((jd - 2451545.0) / 36525.0);
    const lagnaSid = calculateLagna(jd, lat, lng, obliquity, ayanamsa);
    const lagna = { longitude: lagnaSid, rashiIndex: rashiIndex(lagnaSid) };

    return { planets, lagna, ayanamsa };
  }

  return { calculate };
})();
